import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'popup-backdrop',
  templateUrl: './popup-backdrop.component.html',
  styleUrls: ['./popup-backdrop.component.scss'],
  standalone: false,
})
export class PopupBackdropComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
